import { FC, Fragment } from 'react';
import { Link as RRLink, LinkProps } from 'react-router-dom';
import { cn, FaIcon } from '@fe-learner-common';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

type TBreadcrumbItem = { label: string; href: string };
type BreadcrumbProps = {
  rootTitle: string;
  items: Array<TBreadcrumbItem>;
  className?: string;
  isLoading?: boolean;
};

const Link: FC<{ isLoading?: boolean } & LinkProps> = ({
  isLoading,
  ...rest
}) => {
  if (isLoading) {
    return (
      <div className="lf:my-2 lf:h-5 lf:w-[100px] lf:animate-pulse lf:rounded-md lf:bg-neutral-100  lf:text-neutral-100" />
    );
  }

  return <RRLink {...rest} />;
};
export const Breadcrumb: FC<BreadcrumbProps> = ({
  items,
  rootTitle,
  className,
  isLoading,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <nav
      className={cn(
        'lf:-ms-1 lf:flex lf:flex-wrap lf:items-center lf:gap-1 lf:overflow-hidden',
        className,
      )}
    >
      <Link
        isLoading={isLoading}
        to={'/'}
        className="lf:l-btn lf:l-btn-sm lf:l-btn-tertiary"
      >
        <FaIcon className="lf:md:hidden" icon={faArrowLeft} rtlSupport />
        <span className="lf:hidden lf:md:inline">{rootTitle}</span>
      </Link>
      <FaIcon
        className="lf:hidden lf:px-1 lf:text-neutral-500 lf:md:inline"
        icon={faChevronRight}
        rtlSupport
        height={12}
      />
      {items.map((item, index) => {
        return (
          <Fragment key={self.crypto.randomUUID()}>
            <Link
              isLoading={isLoading}
              className={cn(
                'lf:l-btn lf:l-btn-tertiary lf:l-btn-sm lf:whitespace-pre-wrap',
              )}
              to={item.href}
            >
              {item.label}
            </Link>
            {index < items.length - 1 && (
              <FaIcon
                className="lf:px-1 lf:text-neutral-500"
                icon={faChevronRight}
                rtlSupport
                height={12}
              />
            )}
          </Fragment>
        );
      })}
    </nav>
  );
};
